import { useState, useEffect } from 'react';

/**
 * useIsMobile — returns true when the viewport is below 768px.
 *
 * Uses window.matchMedia so the value updates on resize / orientation change
 * without a resize listener. Falls back to false during SSR.
 */
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.matchMedia('(max-width: 767px)').matches;
    });

    useEffect(() => {
        const mql = window.matchMedia('(max-width: 767px)');
        const handler = (e) => setIsMobile(e.matches);
        mql.addEventListener('change', handler);
        // Sync on mount in case initial state was stale
        setIsMobile(mql.matches);
        return () => mql.removeEventListener('change', handler);
    }, []);

    return isMobile;
};

export default useIsMobile;